"use strict";
/*
 * Created on 10.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowStatusConverter_1 = require("./WindowStatusConverter");
/**
 * @author MSu
 */


var WindowStatusConverterImpl =
/*#__PURE__*/
function (_WindowStatusConverte) {
  _inherits(WindowStatusConverterImpl, _WindowStatusConverte);

  function WindowStatusConverterImpl() {
    _classCallCheck(this, WindowStatusConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowStatusConverterImpl).apply(this, arguments));
  }

  return WindowStatusConverterImpl;
}(WindowStatusConverter_1.WindowStatusConverter);

exports.WindowStatusConverterImpl = WindowStatusConverterImpl;